import styled from '@emotion/styled';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Dropdown } from '@lightspeed/flame/Dropdown';
import { Text } from '@lightspeed/flame/Text';

export const ListingFlex = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin: 0;
  border: 2px solid #eaeaea;
  border-top: 0px;
  padding: 8px;
`;

export const AddCardBox = styled(Box)`
  margin: 0;
  padding: 4px 8px;
  border: 2px solid #eaeaea;
  border-top: 0px;
`;

export const AddCardBoxDisabled = styled(Box)`
  margin: 0;
  padding: 4px 8px;
  border: 2px solid #eaeaea;
  border-top: 0px;
  background: #f7f7f7;
`;

export const CardListingText = styled(Text)`
  font-size: 14px;
  color: #333;
  text-transform: none;
`;

export const StyledDropdown = styled(Dropdown)`
  margin: 0;
  padding: 0;
  background: none;
  background-image: none;
  outline: none;
  border: none;
  box-shadow: none;
  cursor: pointer;

  &:not(:focus),
  &:focus,
  &:hover,
  &:active {
    background: none;
    background-image: none;
    outline: none;
    border: none;
    box-shadow: none;
  }
`;

export const StyledDropdownText = styled(Text)`
  font-size: 14px;
  cursor: pointer;
`;

export const AddCardText = styled(Text)`
  font-size: 14px;
  color: #296fb1;
  cursor: pointer;
`;

export const AddCardTextDisabled = styled(Text)`
  font-size: 14px;
  color: #85aace;
  cursor: not-allowed;
  width: 300px;
`;

export const OverlayDiv = styled.div`
  position: absolute;
  margin-top: -37px;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    text-align: center;
    a {
      outline: none;
      padding-left: 4px;
      color: #fff;
      text-decoration: underline;
        &:hover, &:focus, &:active {
          color: #fff;
        }
      }
    }
  }
`;
